import { render } from "./ControlPanelExtraComponent.vue?vue&type=template&id=0ef930de"
import script from "./ControlPanelExtraComponent.vue?vue&type=script&lang=js"
export * from "./ControlPanelExtraComponent.vue?vue&type=script&lang=js"

import "./ControlPanelExtraComponent.vue?vue&type=style&index=0&id=0ef930de&lang=scss"

import exportComponent from "/Users/vincent/Herd/app.prixo.io/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__